import axios from "axios";
import { get, set } from "lodash";
import qs from "qs";
import store from "../store";
import message from "../components/api/message.vue";
import utils, {checkTenantId,getTenantId} from "../utils";
import apis from "./apis";
import * as Sentry from '@sentry/browser';

export const config = {
  timeout: 60000,
  // withCredentials: true,
  //   BASE_URL: '/api',
  headers: {
    // "Content-Type": "application/x-www-form-urlencoded",
    // "Access-User-Token": access_user_token

  }
};
const instance = axios.create(config);
instance.interceptors.request.use(
  config => {
    // let access_token = store.state.user.userInfo.access_token || store.state.user.client.access_token;
    // config.headers['Access-User-Token'] = access_user_token;

    const url = config.url || '';

    if (shouldAddTrace(url)) {
      try {
        // 获取当前的 transaction
        // const transaction = Sentry.getCurrentHub()
        //   .getScope()
        //   ?.getTransaction();

        const hub = Sentry.getCurrentHub();
        const scope = hub.getScope();
        const transaction = scope.getTransaction();

        // if (Sentry) {
        //   const hub = Sentry.getCurrentHub();
        //   const scope = hub.getScope();
        //   if (scope) {
        //       const span = scope.getSpan();
        //       if (span && typeof span.toTraceparent === 'function') {
        //           const traceContext = span.toTraceparent();
        //           console.log(traceContext,'traceContext');

        //           // return traceContext;
        //       }
        //   }
        // }
        if (transaction) {
          // 创建新的 span 或使用现有 span
          const span = transaction.startChild({
            op: 'http.client',
            description: `${config.method} ${url}`,
          });

          // 生成 trace header
          const traceHeader = span.toTraceparent();
          console.log('traceHeader',traceHeader);

          // 添加到请求头
          config.headers['sentry-trace'] = traceHeader;

          // 保存 span 引用，用于响应后结束
          config._sentrySpan = span;
        } else {
          // 如果没有 transaction，可以创建新的
          const transaction = Sentry.startTransaction({
            name: `HTTP ${config.method} ${url}`,
            op: 'http.client',
          });

          const traceHeader = transaction.toTraceparent();
          config.headers['sentry-trace'] = traceHeader;
          config._sentryTransaction = transaction;
        }
      } catch (error) {
        console.warn('Failed to add sentry-trace header:', error);
      }
    }

    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  res => {
    if (typeof res.data == "string") {
      try {
        res.data = JSON.parse(res.data);
      } catch (error) {
        res.data = {
          status: 500
        };
      }
    }
    if (res.config.method == "get") {
      // 获取数据中心uuid
    }
    /**
     * 登录接口和请求成功的接口直接返回
     */
    if (res.data.code === 200 || res.data.access_token) {
      return Promise.resolve(res.data);
    } else if (res.data.code === 203) {
      // 登录接口，账号密码错误
      return Promise.reject(res.data);
    } else {
      let params = res.config.data;
      try {
        params = JSON.parse(params);
      } catch (error) {
        params = {};
      }
      if (!params.noMessage) {
        var component = message
          .$create({
            $props: { text: res.data.error_description || res.data.msg }
          })
          .show();
      }
      // let component = message.$create({
      //     $props: { text: res.data.msg }
      // }).show();
      setTimeout(() => {
        component.remove();
        if (res.data.code === 100) {
          store.commit("user/changeUserinfo", null);
          store.commit("user/changeGuestToken", null);
          window.location.reload();
          // router.push('/login')
        }
      }, 1500);
      return Promise.reject(res.data);
    }
  },
  async err => {
    const originalRequest = err.config;
    if (get(err, 'response.status') === 401 && !originalRequest._retry) {
      //return Promise.reject(res);
      //401判断当前是否有登录，没有登录的无需处理 有登录的用户重新刷新token，重放请求
      let refreshParams = {
        'tenantId': getTenantId(),
        'grant_type': 'refresh_token',
        'scope': 'all',
        'type': 'account',
        'refresh_token':  store.state.user.userinfo.refresh_token
      };
      await apis.login.refreshToken(refreshParams).then(res1 => {
        store.commit("user/changeUserinfo", {...res1});
        originalRequest._retry = true;
        return axios(originalRequest);
      });
    }
    let noErrorMsgAPIs = ["Web_Case/shareCasea"];
    let url = err.config.url;
    let api = noErrorMsgAPIs.find(item => {
      return url.includes(item);
    });
    if (!api) {
      let component = message
        .$create({
          $props: { text: get(err, 'response.data.msg') || "request error" }
        })
        .show();
      setTimeout(() => {
        component.remove();
      }, 3000);
    }

    return Promise.reject(err);
  }
);

const Authorization = 'Basic ' + btoa("h5:h5_secret");
// const Authorization = 'Basic aDU6aDVfc2VjcmV0';

// 需要添加 sentry-trace 的接口白名单
const TRACE_URL_WHITELIST = [
  '/blade-auth/oauth/token',
  '/sd_smi/api/v1/Web_Login/login',
  '/sd_smi/api/v1/Sys_Public/getAppointmentStoreList2?searchTxt'
  // 其他需要 tracing 的接口
];
// 判断是否需要添加 trace
function shouldAddTrace(url) {
  return TRACE_URL_WHITELIST.some(pattern => {
    if (pattern instanceof RegExp) {
      return pattern.test(url);
    }
    return url.includes(pattern);
  });
}
export function request(
  method = "get",
  url,
  params = {},
  type = "from-data",
  otherParams = { takeGuest: true }
) {
  const {useParams,headers,queryParams} = otherParams;
  if (otherParams.checkLogin && !store.getters.isLogin) {
    return utils.toLogin();
  }
  // 默认传参datacenter_uuid 用tenantId代替
  // if (!params.datacenter_uuid) {
  //   params.datacenter_uuid = store.state.common.datacenteruuid;
  // }

  if (!url.includes("http://") && !url.includes("https://")) {
    url = store.state.baseUrl + url;
  }

  method = method.toLowerCase();
  const access_user_token = store.state.user.userinfo.access_token || "";
  const transformData = transform(method, params, type);
  const data = transformData.params;


  const requestConfig = {
    method,
    url,
    headers: {
      ...(headers||{}),
      "Content-Type": transformData["Content-Type"],
      "Blade-Auth": 'bearer ' + access_user_token,
      'authorization': Authorization,
      'Blade-Requested-With': 'BladeHttpRequest',
      'User-Type': 'h5',
      'Tenant-Id': getTenantId(),
      'Blade-Lang': localStorage.getItem('language') || 'en', // 默认语言
    },
  };

  // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  //     // return '手机或平板';

  //     requestConfig.headers["Blade-Auth"]="bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJibGFkZXguY24iLCJhdWQiOlsiYmxhZGV4Il0sInRva2VuX3R5cGUiOiJhY2Nlc3NfdG9rZW4iLCJjbGllbnRfaWQiOiJhcHAiLCJ0ZW5hbnRfaWQiOiIwMDAwMDAiLCJ1c2VyX2lkIjoiMTEyMzU5ODgyMTczODY3NTIwNSIsImRlcHRfaWQiOiIxMTEwMzcwODgyMjQzODMwMTUiLCJwb3N0X2lkIjoiMTkzNTk3NDA4OTQ0ODU3OTA3OSIsInJvbGVfaWQiOiIxMTIzNTk4ODE2NzM4Njc1MjAzIiwiYWNjb3VudCI6ImFwcCIsInVzZXJfbmFtZSI6ImFwcCIsIm5pY2tfbmFtZSI6ImFwcCIsInJlYWxfbmFtZSI6ImEgdGVzdCIsInJvbGVfbmFtZSI6ImhyIiwiZGV0YWlsIjp7ImFsaWFzIjoiMjU0NzA2OTY4MTEyIiwiYXBwTGFuZyI6ImVuIiwiYXJlYUNvZGUiOiIiLCJhdmFpbGFibGVQb2ludHMiOjI0NzIsImNoZWNrUmVhc29uIjoiIiwiY2l0eUlkIjoiMzk3NjkiLCJjb3VudHJ5SWQiOiIyMTYiLCJkZWFsZXJOdW1iZXIiOiJkc3RyMDAxIiwiZmlyc3ROYW1lIjoiQSIsImlkIjoiMTg5MjM3NDQwNDUxOTkyMzcxNCIsImlkQ2FyZCI6IjExMSIsImlkY2FyZEJhY2siOiJodHRwczovL21pbmlvLXRlc3QudHd5Zm9yZHRpbGUudG9wL3Zvc2EtdGVzdC91cGxvYWQvMjAyNTAzMTcvZmRhZmQxOWFmODY3MGQ0ZDgxMWY4MzE3MTczMTdlNDAucG5nIiwiaWRjYXJkRnJvbnQiOiJodHRwczovL21pbmlvLXRlc3QudHd5Zm9yZHRpbGUudG9wL3Zvc2EtdGVzdC91cGxvYWQvMjAyNTAzMTcvNzI2MDMxMGZlMmNhOTIyZjE1ZWIxZjBiMzU0OGNlZGEuanBnIiwiaXNDaGVjayI6IjEiLCJpc0RlbGV0ZWQiOjAsImlzR2V0TmV3YmllUGFjayI6MiwiaXNNb3JlTGV2ZWwiOiIyIiwiaXNUZWFjaGVyIjoyLCJsYXN0TmFtZSI6InRlc3QiLCJsZWF2ZVRpbWUiOiIyMDI1LTAzLTExIDE1OjEwOjM2IiwibGV2ZWxJZCI6IjE0NjY2MDA2MDQxMDU1MTc1NyIsImxldmVsTmFtZSI6IkVMLU1BQU4gSC9XIiwicGVybWlzc2lvbkxpc3QiOm51bGwsInBvc2l0aW9uSWQiOjExMjM1OTg4MTY3Mzg2NzUyMDMsInBvc2l0aW9uTmFtZSI6IuS6uuS6iyIsInJldmlld1RpbWUiOiIyMDI1LTAzLTExIDE1OjA5OjUzIiwic3RhdGVJZCI6IjM1MDciLCJzdGF0dXMiOjEsInVzZXJJZCI6IjExMjM1OTg4MjE3Mzg2NzUyMDUifSwiZXhwIjoxNzY1NzA2NDYyLCJuYmYiOjE3NTI3NDY0NjJ9.bq4_RLJwnbpd5KykYmj1HAWSV_cr9XldRcOwANixtg8";
  //     requestConfig.headers["authorization"]="Basic YXBwOmFwcF9zZWNyZXQ=";
  //     requestConfig.headers["User-Type"]='app';

      let header = localStorage.getItem('header')

      if (header) {
        if (window.location.href.includes("header")) {
          localStorage.removeItem('header')
          updateHeader()
          header = localStorage.getItem('header')
        }
        // console.log("使用缓存header",header);
        requestConfig.headers = JSON.parse(header)
        // console.log(header);
      } else {
        updateHeader();
        // console.log(urlObject);
      }
  // } else {
  //     // return '桌面电脑';
  // }
  if(!localStorage.getItem('header'))checkTenantId()

  if (otherParams.takeGuest && !access_user_token) {
    requestConfig.headers["Access-Guest-Token"] = store.state.user.guestinfo.access_guest_token || "";
  }
  if (otherParams.noMessage) params.noMessage = true;
  if (method === "get"|| useParams) {
    requestConfig.params = data;
  } else {
    requestConfig.data = data;
  }

  if(queryParams){
    requestConfig.params = {
      ...(requestConfig.params||{}),
      ...queryParams
    }
  }
  if (url.includes("uploadaws")) {
    delete requestConfig.headers["Blade-Auth"];
    delete requestConfig.headers["Access-Guest-Token"];
  }
  return instance(requestConfig);
}

// 更新header
function updateHeader() {
  let urlObject = '';

  if (window.location.href.includes("header")) {
    // 处理重定向路由
    if (window.location.href.includes("redirectUrl")) {
      let url = decodeURIComponent(window.location.href)
      let index = url.indexOf('header=')
      if(index==-1) return
      urlObject = JSON.parse(decodeURIComponent(url.substring(index+7)))
      // console.log("使用url传递header",urlObject);
      // 判断是否有Id,有则会话存储
      if (urlObject.id||urlObject.courseId) {
        sessionStorage.setItem('courseId',JSON.stringify(urlObject.id||urlObject.courseId))
        delete urlObject.id
        delete urlObject.courseId
      }
      if(urlObject['Tenant-Id']){
        localStorage.setItem('datacenteruuid',urlObject['Tenant-Id'])
        // this.$store.commit("common/changeDataconterId", urlObject['Tenant-Id']);
      }
      localStorage.setItem('header',JSON.stringify(urlObject))
    }else{
      let url = window.location.href.split('?')[1]
      urlObject = JSON.parse(decodeURIComponent(url.split("=")[1]))
      // console.log("使用url传递header",urlObject);
      // 判断是否有Id,有则会话存储
      if (urlObject.id||urlObject.courseId) {
        sessionStorage.setItem('courseId',JSON.stringify(urlObject.id||urlObject.courseId))
        delete urlObject.id
        delete urlObject.courseId
      }
      if(urlObject['Tenant-Id']){
        localStorage.setItem('datacenteruuid',urlObject['Tenant-Id'])
      }
      localStorage.setItem('header',JSON.stringify(urlObject))
    }
      return urlObject
  }
}

function transform(method, params, type) {
  if (type === "from-data") {
    if (method !== "get") {
      params = qs.stringify(params);
    }
    return {
      params,
      "Content-Type": "application/x-www-form-urlencoded"
    };
  } else {
    return {
      params,
      "Content-Type": "application/json"
    };
  }
}

export default instance;



// WEBPACK FOOTER //
// ./src/request/http.js